import React, { useEffect, useState } from 'react';
import { Button, Typography, List, ListItem, ListItemText } from '@mui/material';
import axios from 'axios'
const PreviousInvoices = () => {
    const [invoices, setInvoices] = useState([]);

    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const token = localStorage.getItem("token")
                const res = await axios.get(
                    `${process.env.REACT_APP_MY_API}/api/invoices/all`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                // Axios automatically parses JSON, so no need for res.json()
                setInvoices(res.data);
            } catch (error) {
                console.error("Failed to fetch invoices", error);
            }
        };

        fetchInvoices();
    }, []);


    const downloadInvoice = (id) => {
        window.open(`/api/invoices/download/${id}`, '_blank');
    };

    return (
        <div className="p-6">
            <Typography variant="h5" className="mb-4">Previous Invoices</Typography>
            <List>
                {invoices.map((invoice) => (
                    <ListItem key={invoice._id} divider>
                        <ListItemText
                            primary={`Invoice No: ${invoice.invoiceNo} | Date: ${invoice.invoiceDate}`}
                            secondary={`Customer: ${invoice.customerName} | Amount: ₹${invoice.grossAmount}`}
                        />
                        <Button variant="outlined" onClick={() => downloadInvoice(invoice._id)}>
                            Download
                        </Button>
                    </ListItem>
                ))}
            </List>
        </div>
    );
};

export default PreviousInvoices;